// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"DisplayOnClick_placeholder__3Jnaw"};